import produce from "immer";
import { Action } from "redux";
import { RootState } from ".";

// =============================================================================
// State
// =============================================================================
interface FormState{
  editMode:boolean;
}

export const INITIAL_FORM_STATE: FormState = {
  editMode: false
}

// =============================================================================
// Action Type
// =============================================================================
enum FormActionTypes {
  UPDATE_FORM_EDIT = 'form/update_form_edit',
}

// =============================================================================
// Actions
// =============================================================================
interface UpdateFormEditAction extends Action<FormActionTypes.UPDATE_FORM_EDIT> {
  payload: boolean;
}

type FormActions = UpdateFormEditAction;

// =============================================================================
// Action Creators
// =============================================================================
export const UpdateFormEdit = (isEdit: boolean): UpdateFormEditAction => ({
  type: FormActionTypes.UPDATE_FORM_EDIT,
  payload: isEdit,
});

// =============================================================================
// Reducer
// =============================================================================
export const formReducer = produce((draft: FormState, action: FormActions) => {
  switch (action.type) {
    case FormActionTypes.UPDATE_FORM_EDIT:
      draft.editMode = action.payload;
      break;
    default:
  }
}, INITIAL_FORM_STATE)

// =============================================================================
// Selectors
// =============================================================================
export const selectFormEditMode = (state: RootState) => state.form.editMode;
